module.exports = __webpack_public_path__ + "static/media/metal-handle.87abbd9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/metal-handle.png
// module id = 1225
// module chunks = 0